import { push, pushToPixel } from "../services/sendEvent";
import { debounce } from "../utils/helper";

export const fireCategoryEvent = debounce((data: string[]) => {
	// Call push function with event-label "categories_field_filled" and required payload
	push({
		event_label: "categories_field_filled",
		event_datum: {
			field_information: data
		}
	});
	pushToPixel({
			eventLabel: "Popup-Category-Filled",
		}, true);
}, 1000)
